import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/workflows/{workflowId}/steps/{stepId}']['DELETE'];

const deleteWorkflowStep = async ({ id, stepId }: ThisApi['params']): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.delete(`/workflows/${id}/steps/${stepId}`);
  return response.data;
};

export default deleteWorkflowStep;
